import React, {useEffect, useState} from 'react'
import "./completeAccount.css"
import send from "../../../Images/send.png"
import { useNavigate } from "react-router";
import axios from 'axios';
import { toast } from "../../../utils/appToast";
import OtpPage from '../OtpSection/OtpPage';
import verifylogo from "../../../Images/verified.png"
import errorEmailLogo from '../../../Images/emailerror.png'


export const CompleteAccount = () => {

  const [showModal, setShowModal] = useState(false);
  const [modalEmail, setModalEmail] = useState("");
  const [emailAccountVerified, setEmailAccountVerified] = useState(false)
  const [emailVerificationError, setEmailVerificationError] = useState(false)
  const [completeAccountDetails, setCompleteAccountDetails] = useState({
    firstName: "",
    lastName: "",
    billingEmail: "",
    contactNumber: "",
    orgName: "", 
  });
   
    const [email, setEmail] = useState('');
   
  
    useEffect(()=>{
      const storeEmail = localStorage.getItem('email')
      if(storeEmail){
        setEmail(storeEmail)
      }
    },[])
    

  const openModal = () => {
    setModalEmail(completeAccountDetails.email);
    setShowModal(true);
    setEmailVerificationError("");
  };

  const closeModal = () => {
    setShowModal(false);
  };

    const navigate = useNavigate();

   

    const handleValueChange = (e)=>{
      // e.target.value();
      const {name, value} = e.target;
      setCompleteAccountDetails((prevCompleteAccountDetail) => ({
        ...prevCompleteAccountDetail,
        [name]: value,
      }));
      
    }


    const token = localStorage.getItem('token');

    const handleSubmit = async (e)=>{
      e.preventDefault();

      if(!token){
        navigate('/signup');
        return;
      }

      if (!emailAccountVerified) {
        setEmailVerificationError("Your Email is not verified, Please verify your Email ID to Continue");
        return;  
      }

      const payload = {
        first_name: completeAccountDetails.firstName,
        last_name: completeAccountDetails.lastName,
        contact_no: completeAccountDetails.contactNumber,
        alternate_email: completeAccountDetails.billingEmail,
        organization_name: completeAccountDetails.orgName
      }
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}api/v1/accounts/get-customer-data/`,
            payload,
          {
            headers: {
              Authorization: `Token ${localStorage.getItem('token')}`,
              "Content-Type": "application/json",
            }
          }
        )
        if (response.status === 200) {
          toast.success("Data submitted successfully", {
            autoClose: 2000,    
          });
          window.localStorage.setItem("first_name", completeAccountDetails.firstName);
          window.localStorage.setItem("last_name", completeAccountDetails.lastName);
          navigate("/pricing");
        }
      } catch (error) {
        
      }
    }

 
  
    // return (
   
  
    //   </div>
    // );
}
